import {
  VERIFY_TRIBUN_REQUEST,
  VERIFY_TRIBUN_SUCCESS,
  VERIFY_TRIBUN_FAILURE,
} from 'Store/constants';

const initialState = {
  data: '',
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_TRIBUN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case VERIFY_TRIBUN_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case VERIFY_TRIBUN_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};